import { qprConstants } from '../Constants';

const qpr = (qpr) => {
  return {
    type: qprConstants.QPR_SUCCESS,
    payload: qpr
  }
}

const qprData = (qpr_data) => {
	return {
		type: qprConstants.QPR_DATA_SUCCESS,
		payload: qpr_data
	}
}

// const basicInformation = (qpr) => {
//   return {
//     type: qprConstants.BASIC_INFORMATION_SUCCESS,
//     payload: qpr
//   }
// }

// const researchBackgroundSave = (res, qpr) => {
//   qpr.research_background = res.data.research_background;
//   localStorage.setItem("qpr", JSON.stringify(qpr));
//   return this.qpr(qpr);  
// }

export const qprActions = {
  qpr,
  qprData,
  // basicInformation,
  // researchBackgroundSave
};